import React, {FC} from "react";
import logo from "../assets/logo.png";

interface ILogo {
    src?: string;
}

export const Logo: FC<ILogo> = ({src}) => {
    return (
        <div style={{}}>
            <img src={src || logo}
                alt="Logo"
                style={{
                    height: "50px",
                    width: "50px",
                }}/>
        </div>
    );
};


